import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import Home from "./pages/Home";
import BlocksPage from "./pages/BlocksPage";
import BlockDetail from "./pages/BlockDetail";
import TransactionsPage from "./pages/TransactionsPage";
import TransactionDetail from "./pages/TransactionDetail";
import AddressPage from "./pages/AddressPage";
import MempoolPage from "./pages/MempoolPage";
import StatsPage from "./pages/StatsPage";
import ValidatorsPage from "./pages/ValidatorsPage";
import MinersPage from "./pages/MinersPage";
import TokenomicsPage from "./pages/TokenomicsPage";
import SearchPage from "./pages/SearchPage";
import ApiDocsPage from "./pages/ApiDocsPage";
import NotFoundPage from "./pages/NotFoundPage";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blocks" element={<BlocksPage />} />
          <Route path="/block/:identifier" element={<BlockDetail />} />
          <Route path="/transactions" element={<TransactionsPage />} />
          <Route path="/tx/:hash" element={<TransactionDetail />} />
          <Route path="/address/:address" element={<AddressPage />} />
          <Route path="/mempool" element={<MempoolPage />} />
          <Route path="/stats" element={<StatsPage />} />
          <Route path="/validators" element={<ValidatorsPage />} />
          <Route path="/miners" element={<MinersPage />} />
          <Route path="/tokenomics" element={<TokenomicsPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/api-docs" element={<ApiDocsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
